import { NavLink, Link } from "react-router-dom";
import ToggleThemeButton from "./themebutton";
export default function Navigator() {
  return (
    <header className="site-header">
      <Link to="/" className="site-brand" aria-label="Enqurance home">
        Enqurance
      </Link>
      <nav aria-label="Main navigation">
        <NavLink end to="/">
          Home
        </NavLink>
        <NavLink to="/resume">Resume</NavLink>
        <NavLink to="/blogs">Blogs</NavLink>
      </nav>
      <ToggleThemeButton />
    </header>
  );
}
